import React from "react";
import '../Page/Page.css';
import './SlideComp.css'

interface Slide {
    source: string;
    title?: string;
    id? : string;
}



const SlideComp: React.FC<Slide> = ({ source, title, id}) => {


    return (
        <div className="slideContainer" id={id}>

            <h1 className='subTitle'>{title}</h1>
            <img src={source} className="slideImg" />
        </div>
    )
};
export default SlideComp;